import React, { useEffect, useState } from 'react'
import { FormContext, useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import {
  Button,
  Grid,
  InputAdornment,
  Paper,
  TextField,
  Tooltip,
  Typography,
  Box,
} from '@material-ui/core'
import ImportEmailsDialog from 'views/Consent/components/ImportEmailsDialog'
import { routes } from 'Routes'
import { useHistory } from 'react-router-dom'

import { TextFieldList } from 'components'

import useSnackbar from 'hooks/useSnackbar'
import useConsent from 'hooks/useConsent'

import helpers from 'helpers'
import * as service from 'service'

import schema from './schema'
import useStyles from './styles'
import constants from 'constants/index'
import { getBaseURL } from 'service/env'

const Sharing = ({ tokenPrivacyPortal }) => {
  const history = useHistory()
  const portalURL = getBaseURL('privacyPortal')
  const classes = useStyles()
  const snackbar = useSnackbar()

  const [openImportDialog, setOpenImportDialog] = useState(false)

  const { toNextStep, setToNextStep, setIsConsentLoading } = useConsent()

  const formMethods = useForm({
    validationSchema: schema,
    mode: 'onChange',
    defaultValues: {
      email: '',
      emailList: [],
    },
  })
  const {
    handleSubmit,
    formState: { isValid },
  } = formMethods

  const linkToPortal = `${portalURL}/consent-forms?token=${tokenPrivacyPortal}`

  useEffect(() => {
    if (toNextStep) {
      handleSubmit(onSubmit)()

      if (!isValid) setToNextStep(false)
    }
    // eslint-disable-next-line
  }, [toNextStep])

  const handleOpenImportDialog = () => {
    setOpenImportDialog(true)
  }

  const onSubmit = async (data) => {
    setIsConsentLoading(true)

    try {
      if (data?.emailList) {
        await service.dponet.consent.sendLink({
          token: tokenPrivacyPortal,
          email: data?.emailList.map((item) => item),
        })
      }

      snackbar.open({
        message: 'Formulário de consentimento criado com sucesso!',
        variant: 'success',
      })
      history.push(routes.consent.all)
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error, false) ||
          error?.error?.message,
        variant: 'error',
      })
    } finally {
      setIsConsentLoading(false)
    }
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(linkToPortal)
  }

  return (
    <FormContext {...formMethods}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        id={constants.consent.NEW_CONSENT_FORM_DRIVER_STEP_5}
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="subtitle2" gutterBottom>
              Publicar formulário
            </Typography>
            <Typography>
              Torne o seu formulário público, compartilhando o endereço
              eletrônico do formulário com os titulares de dados.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="copy-field"
              label="Link para o formulário"
              value={linkToPortal}
              fullWidth
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleCopy}
                    >
                      Copiar
                    </Button>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Paper className={classes.descriptionBox}>
              <Box className={classes.paperBox}>
                <Box>
                  <Typography variant="subtitle2">
                    Compartilhar por e-mail
                  </Typography>
                  <Typography>
                    Indique um e-mail ou importe um arquivo para receber um link
                    para o formulário, podendo ser compartilhado com os
                    titulares de dados
                  </Typography>
                </Box>
                <Box className={classes.containerButton}>
                  <Tooltip title="Importar e-mails de uma planilha (CSV ou XLSX)">
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={handleOpenImportDialog}
                    >
                      Importar
                    </Button>
                  </Tooltip>
                </Box>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <TextFieldList
              label="Adicionar e-mail"
              controlName="email"
              arrayControlName="emailList"
              containerTitle="E-mails adicionados"
            />
          </Grid>
        </Grid>
        <ImportEmailsDialog
          open={openImportDialog}
          setOpen={setOpenImportDialog}
          token={tokenPrivacyPortal}
        />
      </form>
    </FormContext>
  )
}

Sharing.propTypes = {
  tokenPrivacyPortal: PropTypes.string.isRequired,
}

export default Sharing
